// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__346Bb","productName":"Table_productName__1a_Bq"};